export default (() => {
    var ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf('iphone') !== -1 || ua.indexOf('ipad') !== -1) {
        return 'ios';
    }
    else if (ua.indexOf('android') !== -1) {
        return 'android';
    }
    else if (ua.indexOf('edge') !== -1) {
        return 'edge';
    }
    else if (ua.indexOf('meie') !== -1 || ua.indexOf('trident') !== -1) {
        return 'ie';
    }
    else if (ua.indexOf('firefox') !== -1) {
        return 'firefox';
    }
    else if (ua.indexOf('chrome') !== -1 && window.chrome) {
        return 'chrome';
    }
    else if (ua.indexOf('safari') !== -1) {
        return 'safari';
    }
    else {
        return 'unknown';
    }
})();